import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import ru from './locales/ru.json'
import { isDealerPortal } from '../dealer/portal'

// клиентские страницы (отчёт, verify-email) по умолчанию на английском, отчёт затем переключается на язык ДЦ;
// админка остаётся на русском — у неё нет переключателя языка; портал дилера — на английском
const defaultLng = isDealerPortal()
  ? 'en'
  : window.location.pathname.startsWith('/admin') ? 'ru' : 'en'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
    },
    lng: defaultLng,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
